import React, { useEffect } from "react";
import {
  HeroSection,
  AboutSection,
  StatsSection,
  FeaturedServicesSection,
  ProcessSection,
  WhyChooseUsSection,
  ClientLogosSection,
  CaseStudySection,
  TestimonialsSection,
  CTASection,
  SEO,
  usePerformanceMonitor,
} from "../components";
import AOS from "aos";
import "aos/dist/aos.css";

const Home = () => {
  // Performance monitoring
  usePerformanceMonitor();

  useEffect(() => {
    // Initialize AOS animation library
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-out",
    });
  }, []);

  // Structured data for the home page
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "GrowthVibe - Premier IT & Digital Marketing Agency",
    description:
      "Elevate your brand with strategic marketing solutions. We specialize in web development, SEO, and digital marketing to drive growth and maximize ROI.",
    url: "https://growthvibe.com",
    mainEntity: {
      "@type": "Organization",
      name: "GrowthVibe",
      url: "https://growthvibe.com",
      logo: "https://growthvibe.com/images/FINAL-LOGO-GV.png",
      description:
        "Leading IT and digital marketing agency specializing in web development, SEO, social media marketing, and brand identity design.",
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "+91-78610-83648",
        contactType: "Customer Service",
        email: "growthvibe2406@gmail.com",
      },
      address: {
        "@type": "PostalAddress",
        addressLocality: "Surat",
        addressRegion: "Gujarat",
        addressCountry: "IN",
      },
      sameAs: [
        "https://www.facebook.com/profile.php?id=61578656210527",
        "https://x.com/growth_vibe",
        "https://www.instagram.com/growthvibe24",
      ],
    },
  };

  return (
    <>
      <SEO
        title="GrowthVibe - Premier IT & Digital Marketing Agency"
        description="Elevate your brand with strategic marketing solutions. We specialize in web development, SEO, and digital marketing to drive growth and maximize ROI."
        keywords="digital marketing, web development, SEO services, social media marketing, IT agency, brand identity, website design, GrowthVibe, marketing solutions, Surat, Gujarat"
        url="/"
        structuredData={structuredData}
      />
      <div className="home-page overflow-hidden">
        {/* Hero Section */}
        <HeroSection />

        {/* About Section */}
        <AboutSection />

        {/* Stats Section */}
        {/* <StatsSection /> */}

        {/* Featured Services */}
        <FeaturedServicesSection />

        {/* Process Section */}
        <ProcessSection />

        {/* Why Choose Us */}
        <WhyChooseUsSection />

        {/* Client Logos */}
        {/* <ClientLogosSection /> */}

        {/* Case Studies */}
        {/* <CaseStudySection /> */}

        {/* Testimonials */}
        {/* <TestimonialsSection /> */}

        {/* CTA Section */}
        <CTASection />
      </div>
    </>
  );
};

export default Home;
